import { useT } from "../../i18n/hooks.ts";
import { isPointTool, TOOL_LABEL, type DrawingTool } from "../drawingTools.ts";

/**
 * Button to activate hand-drawing for ONE specific tool on the map (the 3
 * used to live together in a single "Draw" tab — now each catalog has its
 * own, alongside the rest of its actions). Available from card view too —
 * `onStartDrawing` (App.tsx's startDrawing) switches to map view on its
 * own, since there's nowhere to draw otherwise. With the mode active it
 * can be cancelled.
 */
export function DrawButton({
  tool,
  drawingMode,
  onStartDrawing,
  onCancelDrawing,
}: {
  tool: DrawingTool;
  drawingMode: DrawingTool | null;
  onStartDrawing: (tool: DrawingTool) => void;
  onCancelDrawing: () => void;
}) {
  const t = useT();
  const active = tool === drawingMode;
  return (
    <div className="draw-buttons-panel">
      <button
        className={active ? "button button-primary" : "button"}
        onClick={() => onStartDrawing(tool)}
      >
        {isPointTool(tool) ? "📍" : "▱"} {t("drawButton.draw", { tool: t(TOOL_LABEL[tool]) })}
      </button>
      {active && (
        <button className="button" onClick={onCancelDrawing}>
          {t("drawButton.cancelDrawing")}
        </button>
      )}
    </div>
  );
}
